import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getViewForChart, getViewGroupForChart } from '../../redux/sonar/sonarSelectors';
import { Panel } from '../../components/layout/layout';
import WithToolbarWrapper from '../with-toolbar-wrapper/WithToolbarWrapper';
import ExtendedViewToolbar from '../extended-view-toolbar/ExtendedViewToolbar';
import { EXTENDED_CHART_TYPES } from '../../utils/chart';
import BubblesChart from '../../components/charts/d3/bubbles/BubblesChart';
import ScatterChart from '../../components/charts/d3/scatter/ScatterChart';

function BottomCharts({
  chartIndex,
  section,
  viewOptions,
  dataKey,
  getEntriesSelector,
  isTrendReversed,
  scatterDataKeys,
  scatterXLabel,
  scatterYLabel,
  getColor,
}) {
  const { t } = useTranslation('sonar');

  const view = useSelector(getViewForChart(section, chartIndex));
  const group = useSelector(getViewGroupForChart(section, chartIndex));

  //! TEMPORARY SOLUTION
  let domainEntries = useSelector(getEntriesSelector(view, group));

  if (domainEntries.length && !domainEntries[0][dataKey]) {
    domainEntries = [];
  }

  return (
    <Panel>
      <WithToolbarWrapper>
        <ExtendedViewToolbar chartIndex={chartIndex} section={section} viewOptions={viewOptions} allowGroupsFilter>
          {({ chartType }) => {
            return chartType === EXTENDED_CHART_TYPES.BUBBLES ? (
              <BubblesChart
                data={domainEntries}
                dataKey={dataKey}
                view={view}
                forceClusterByGroup={group !== 'ALL'}
                reverseTrendGroup={isTrendReversed}
              />
            ) : (
              <ScatterChart
                data={domainEntries}
                dataKeys={scatterDataKeys}
                xLabel={scatterXLabel || t('score')}
                yLabel={scatterYLabel || t('trend')}
                getColor={getColor}
                reverseTrendGroup={isTrendReversed}
              />
            );
          }}
        </ExtendedViewToolbar>
      </WithToolbarWrapper>
    </Panel>
  );
}

export default BottomCharts;
